import {Box} from '@mui/material';
import {Form, Formik, FormikHelpers} from 'formik';
import {FC} from 'react';

import LoadingButton from 'components/UI/LoadingButton';
import useTranslate from 'hooks/useTranslate';
import {useAppDispatch, useAppSelector} from 'redux/redux';
import {LoginSchema} from 'utils/validation-schema';

import InputField from 'components/UI/form/InputField';
import {LoginData} from 'models/user-interface';
import {selectLoading} from 'redux/auth/selector';
import {loginUserAsync} from 'redux/auth/thunk';
import VersionBadge from '../components/shared/version-badge/VersionBadge';

const Login: FC = () => {
  const dispatch = useAppDispatch();
  const {parseUI} = useTranslate();
  const loading = useAppSelector(selectLoading);

  const initialValues = {
    email: '',
    password: '',
  };

  // Handle form submission
  const handleSubmit = async (values: LoginData, actions: FormikHelpers<LoginData>) => {
    values = {...values, portal: 'web-admin'};
    const loginResponse = await dispatch(loginUserAsync(values)).unwrap();
    if (loginResponse) {
      actions.resetForm();
    }
  };

  return (
    <Box
      className="loginWrapper"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: '#091d58',
      }}>
      <img src="/static/images/svg/logo.svg" width={300} alt="Baitchecker" />
      <h1 className="text-white-50 py-3">
        {parseUI('SUPERADMIN_LOGIN')} <VersionBadge />
      </h1>

      <Formik initialValues={initialValues} validationSchema={LoginSchema} onSubmit={handleSubmit}>
        {({isValid, dirty}) => (
          <Form className="login-outer">
            <InputField name="email" type="email" label="EMAIL" />
            <InputField name="password" type="password" label="PASSWORD" />
            <div className="btn-end">
              <LoadingButton
                type="submit"
                label="LOGIN"
                loader={loading}
                className="loading-button"
                disabled={!isValid || !dirty || loading === true}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default Login;
